export var TeamRole;
(function (TeamRole) {
    TeamRole["ADMIN"] = "ADMIN";
    TeamRole["OWNER"] = "OWNER";
    TeamRole["EDITOR"] = "EDITOR";
    TeamRole["VIEWER"] = "VIEWER";
    TeamRole["REVIEWER"] = "REVIEWER";
})(TeamRole || (TeamRole = {}));
